import {objectSources as objectSourceChoices} from "../sources/object-sources";
import {ObjectSource, ObjectSourceCategory} from "../sources/types";
import {DestinationSlug} from "../destinations/types";
import {LoadedDestinationInfo} from "../types/global";
import {DestinationState, SET_DESTINATION_DATA} from "./destinations";
import {Reducer} from "redux";

export const LOAD_CONFIGURED_OBJECT_SOURCES = "LOAD_OBJECT_SOURCES";
export const SET_OBJECT_SOURCES_LOADING = "SET_OBJECT_SOURCES_LOADING";
export const SET_OBJECT_SOURCES_NOT_LOADING = "SET_OBJECT_SOURCES_NOT_LOADING";

export enum ObjectSourceSetupState {
    INCOMPLETE = 'incomplete',
    BROKEN = 'broken',
    CONNECTED = 'connected',
}

export enum ObjectSourceSyncState {
    PAUSED = 'paused',
    SCHEDULED = 'scheduled',
    RESCHEDULED = 'rescheduled',
}

export type ConfiguredObjectSource = {
    destinationID: string;
    groupID: string;
    fivetranID: string;
    is_historical_sync: boolean;
    service: ObjectSource['fivetranService'];
    setup_state: ObjectSourceSetupState;
    sync_state: ObjectSourceSyncState;
    update_state: string;
};

export interface ObjectStateState {
    configured: ConfiguredObjectSource[];
    choices: Array<ObjectSource | ObjectSourceCategory>;
    loading: boolean;
}

export const initialObjectSourcesState = {
    configured: [],
    choices: objectSourceChoices,
    loading: true,
} as ObjectStateState;


// Actions
type SetConfiguredObjectSourcesAction = {
    type: typeof LOAD_CONFIGURED_OBJECT_SOURCES;
    payload: ConfiguredObjectSource[];
};

type SetObjectSourcesLoading = {
    type: typeof SET_OBJECT_SOURCES_LOADING;
};

type SetObjectSourcesNotLoading = {
    type: typeof SET_OBJECT_SOURCES_NOT_LOADING;
};

type ObjectSourcesActions =
    | SetConfiguredObjectSourcesAction
    | SetObjectSourcesLoading
    | SetObjectSourcesNotLoading;

const objectSourcesReducer: Reducer<ObjectStateState, ObjectSourcesActions> = (
    state = initialObjectSourcesState,
    action
) => {
    switch (action.type) {
        case LOAD_CONFIGURED_OBJECT_SOURCES:
            return {
                ...state,
                configured: action.payload || [],
                loading: false,
            };
        case SET_OBJECT_SOURCES_LOADING:
            return {...state, loading: true};
        case SET_OBJECT_SOURCES_NOT_LOADING:
            return {...state, loading: false};
        default:
            return state;
    }
}

export default objectSourcesReducer;
